// Import statement to make this a proper TypeScript module
//import React from 'react';


const API_URL = 'https://iam-sso-west-eur-hfdpfhefgzd6g7gm.westeurope-01.azurewebsites.net/v1';

export async function signIn(user: { email: string; password: string; save: boolean }) {
  const response = await fetch(`${API_URL}/users/signin`, {
    method: 'POST',
    headers: { 
      'Content-Type': 'application/json'
    },
    credentials: 'include',
    body: JSON.stringify(user),
    referrerPolicy: 'strict-origin-when-cross-origin',
  });
  if (!response.ok) {
    const errData = await response.json();
    throw new Error(errData?.Message || errData?.error || 'Sign in failed.');
  }
  return response.json();
}

export async function signUp(user: { name: string; email: string; }) {
  const response = await fetch(`${API_URL}/accounts/signup`, {
    method: 'POST',
    headers: { 
      'Content-Type': 'application/json'
    },
    credentials: 'include',
    body: JSON.stringify(user),
    referrerPolicy: 'strict-origin-when-cross-origin',
  });
  if (!response.ok) {
    console.log('Response status:', response.status);
    console.log('Response headers:', response.headers);
    
    let errorMessage = 'Sign up failed.';
    try {
      const errData = await response.json();
      console.log('JSON response:', errData);
      errorMessage = errData?.Message || errData?.error || errData || errorMessage;
    } catch (parseError) {
      console.log('JSON parse error:', parseError);
      // If JSON parsing fails, try to get the response as text
      try {
        const textResponse = await response.text();
        console.log('Text response:', textResponse);
        errorMessage = textResponse || errorMessage;
      } catch (textError) {
        console.log('Text parse error:', textError);
        // If all else fails, use the status text
        errorMessage = response.statusText || errorMessage;
      }
    }
    console.log('Final error message:', errorMessage);
    throw new Error(errorMessage);
  }
  return response.json();
}

export async function resetPassword(data: { Email: string }) {
  const response = await fetch(`${API_URL}/users/reset-password`, {
    method: 'PUT',
    headers: { 
      'Content-Type': 'application/json'
    },
    credentials: 'include',
    body: JSON.stringify(data),
    referrerPolicy: 'strict-origin-when-cross-origin',
  });
  if (!response.ok) {
    let errorMessage = 'Reset password failed.';
    try {
      const errData = await response.json();
      errorMessage = errData?.Message || errData?.error || errData || errorMessage;
    } catch (parseError) {
      // If JSON parsing fails, try to get the response as text
      try {
        const textResponse = await response.text();
        errorMessage = textResponse || errorMessage;
      } catch (textError) {
        // If all else fails, use the status text
        errorMessage = response.statusText || errorMessage;
      }
    }
    throw new Error(errorMessage);
  }
  return response.json();
}

export async function updatePassword(data: { OldPassword: string; NewPassword: string }, userId: string, reset: boolean = false) {
  const endpoint = reset ? `${API_URL}/users/${userId}/password/reset` : `${API_URL}/users/${userId}/password`;
  
  const response = await fetch(endpoint, {
    method: 'PUT',
    headers: { 
      'Content-Type': 'application/json'
    },
    credentials: 'include',
    body: JSON.stringify(data),
    referrerPolicy: 'strict-origin-when-cross-origin',
  });
  if (!response.ok) {
    let errorMessage = 'Update password failed.';
    try {
      const errData = await response.json();
      errorMessage = errData?.Message || errData?.error || errData || errorMessage;
    } catch (parseError) {
      // If JSON parsing fails, try to get the response as text
      try {
        const textResponse = await response.text();
        errorMessage = textResponse || errorMessage;
      } catch (textError) {
        // If all else fails, use the status text
        errorMessage = response.statusText || errorMessage;
      }
    }
    throw new Error(errorMessage);
  }
  return response.json();
}

export async function verifyAccount(data: any, userId: string) {
  const response = await fetch(`${API_URL}/users/${userId}/verify`, {
    method: 'PUT',
    headers: { 
      'Content-Type': 'application/json'
    },
    credentials: 'include',
    body: JSON.stringify(data),
    referrerPolicy: 'strict-origin-when-cross-origin',
  });
  if (!response.ok) {
    let errorMessage = 'Account verification failed.';
    try {
      const errData = await response.json();
      errorMessage = errData?.Message || errData?.error || errData || errorMessage;
    } catch (parseError) {
      // If JSON parsing fails, try to get the response as text
      try {
        const textResponse = await response.text();
        errorMessage = textResponse || errorMessage;
      } catch (textError) {
        // If all else fails, use the status text
        errorMessage = response.statusText || errorMessage;
      }
    }
    throw new Error(errorMessage);
  }
  return response.json();
}

export async function getProfile(userId: string) {
  const response = await fetch(`${API_URL}/users/${userId}`, {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
    },
    credentials: 'include',
    referrerPolicy: 'strict-origin-when-cross-origin',
  });
  if (!response.ok) {
    let errorMessage = 'Failed to fetch profile.';
    try {
      const errData = await response.json();
      errorMessage = errData?.Message || errData?.error || errData || errorMessage;
    } catch (parseError) {
      try {
        const textResponse = await response.text();
        errorMessage = textResponse || errorMessage;
      } catch (textError) {
        errorMessage = response.statusText || errorMessage;
      }
    }
    throw new Error(errorMessage);
  }
  return response.json();
}

export async function updateProfile(data: { Name: string; Email: string }, userId: string) {
  const response = await fetch(`${API_URL}/users/${userId}`, {
    method: 'PUT',
    headers: {
      'Content-Type': 'application/json',
    },
    credentials: 'include',
    body: JSON.stringify(data),
    referrerPolicy: 'strict-origin-when-cross-origin',
  });
  if (!response.ok) {
    let errorMessage = 'Failed to update profile.';
    try {
      const errData = await response.json();
      errorMessage = errData?.Message || errData?.error || errData || errorMessage;
    } catch (parseError) {
      try {
        const textResponse = await response.text();
        errorMessage = textResponse || errorMessage;
      } catch (textError) {
        errorMessage = response.statusText || errorMessage;
      }
    }
    throw new Error(errorMessage);
  }
  return response.json();
}

export async function googleSignIn(data: { email: string; token: string }) {
  const response = await fetch(`${API_URL}/users/signin/google`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    credentials: 'include',
    body: JSON.stringify(data),
    referrerPolicy: 'strict-origin-when-cross-origin',
  });
  if (!response.ok) {
    let errorMessage = 'Google Sign-In failed.';
    try {
      const errData = await response.json();
      errorMessage = errData?.Message || errData?.error || errData || errorMessage;
    } catch (parseError) {
      errorMessage = response.statusText || 'Google Sign-In failed.';
    }
    throw new Error(errorMessage);
  }
  return response.json();
}

export async function googleSignUp(data: { name: string; email: string; token: string }) {
  const response = await fetch(`${API_URL}/accounts/signup/google`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    credentials: 'include',
    body: JSON.stringify(data),
    referrerPolicy: 'strict-origin-when-cross-origin',
  });
  if (!response.ok) {
    let errorMessage = 'Google Sign-Up failed.';
    try {
      const errData = await response.json();
      errorMessage = errData?.Message || errData?.error || errData || errorMessage;
    } catch (parseError) {
      errorMessage = response.statusText || 'Google Sign-Up failed.';
    }
    throw new Error(errorMessage);
  }
  return response.json();
}

// Export statement to make this a proper TypeScript module
export {}; 